import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useSession } from 'next-auth/react';
import mixpanel from 'mixpanel-browser';
import { useGetEmployeeRole } from '~/entities/RoleSetting/api/useGetEmployeeRole';
import { roleFlags } from '~/shared/utils/roleFlags';
import { initMixpanel } from '../../../mixpanelClient';
import { useUser } from '../auth/useUser';

export function useInitMixPanel() {
  const router = useRouter();
  const { data } = useSession();
  const user = useUser();
  const { data: employeeRole } = useGetEmployeeRole(user.employeeId || '');

  useEffect(() => {
    initMixpanel();

    if (data && process.env.NEXT_PUBLIC_MIXPANEL_TOKEN) {
      const { user: session } = data;
      const roles = roleFlags(employeeRole?.role);
      mixpanel.identify(user.employeeId);
      mixpanel.people.set({
        $name: session.name,
        $email: session?.email,
        globalId: user.globalId,
        zone: user?.zone,
        band: user?.band,
        isManager: roles.isManager,
        isSuperAdmin: roles.isSuperAdmin,
        isGlobalAdmin: roles.isGlobalAdmin,
        isZoneAdmin: roles.isZoneAdmin,
        isPBP: roles.isPBP,
        isTalentManager: roles.isTalentManager,
      });
    }
  }, [data, user, employeeRole?.role, router.events]);
}
